import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './checkbox.scss';

const Checkbox = ({
  isChecked = false,
  onChange = () => {},
  name = '',
  label = '',
  hasError = false,
  validationType,
}) => {
  const [isCheckedValue, setIsCheckedValue] = useState(isChecked);

  const classNames = hasError ? 'form-checkbox error' : 'form-checkbox';

  const handleChange = () => {
    setIsCheckedValue(!isCheckedValue);
    onChange(name, !isCheckedValue, validationType);
  };

  return (
    <>
      <input
        className={classNames}
        name={name}
        checked={isCheckedValue}
        type='checkbox'
        onChange={handleChange}
        aria-label={label}
      />
      <span className='checkbox-text'>
        <span>I have read and agree to the </span>
        <a
          href='https://www.brandworkz.com/terms-and-conditions/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Terms & Conditions
        </a>
        <span> and </span>
        <a
          href='https://www.brandworkz.com/privacy-policy/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Privacy Policy
        </a>
      </span>
    </>
  );
};

Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  hasError: PropTypes.bool,
};

export default Checkbox;
